
import { mapGetters, mapMutations } from "vuex";
import menuBookMenuItem from "./menu-book-menu-item.vue";
export default {
  components: { menuBookMenuItem },
  props: {
    brandId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.SET_BRAND_FILTER(+this.brandId);
  },
  computed: {
    ...mapGetters("menu", ["getGroupedMenu"]),
    filteredMenu() {
      let categoryArray = this.getGroupedMenu.filter(
        (item) => item.id !== "all-items"
      );

      const searchTerm = this.search && this.search.trim().toLowerCase();
      if (searchTerm) {
        return categoryArray.map((category) => {
          const filteredItems = category.items.filter((item) => {
            return (
              item.item_name &&
              item.item_name.toLowerCase().includes(searchTerm)
            );
          });
          let filteredSubcategories = [];
          if (category.subcategories) {
            filteredSubcategories = category.subcategories
              .map((subcategory) => ({
                ...subcategory,
                items: subcategory.items.filter((item) => {
                  return (
                    item.item_name &&
                    item.item_name.toLowerCase().includes(searchTerm)
                  );
                })
              }))
              .filter((subcategory) => subcategory.items.length > 0);
          }

          return {
            ...category,
            items: filteredItems,
            subcategories: [...filteredSubcategories]
          };
        });
      } else {
        return categoryArray;
      }
    }
  },
  data() {
    return {
      search: "",
      value: false
    };
  },
  methods: {
    ...mapMutations("menu", ["SET_BRAND_FILTER"]),

    getItemsCount(category) {
      if (category && category.subcategories && category.subcategories.length) {
        let count = category.items.length;
        category.subcategories.forEach((subcategory) => {
          count +=
            subcategory.items && subcategory.items.length
              ? subcategory.items.length
              : 0;
        });
        return count;
      } else if (category.items && category.items.length) {
        return category.items.length;
      } else {
        return "0";
      }
    }
  }
};
